const variant: 'A' | 'B' = Math.random() < 0.5 ? 'A' : 'B'
window.mixpanel?.register?.({ banner_variant: variant })

export function useBannerABTest() {
  const trackImpression = () => {
    window.mixpanel?.track?.('Banner Impression', { banner_variant: variant })
  }

  const trackClick = () => {
    window.mixpanel?.track?.('Banner Click', { banner_variant: variant })
  }

  return { variant, trackImpression, trackClick }
}
